import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MeetingService } from './meeting.service';
import { Observable } from 'rxjs';
import { HistoryComponent } from '../components/history/history.component';
import { SideNavServiceService } from './side-nav-service.service';
import { environment_msg } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HistoryDialogService {

  constructor(
    private dialog: MatDialog,
    private meetingService: MeetingService,
    private notifier: SideNavServiceService,
  ) {}

  openHistoryDialog(entityId: any, entityType: any, modifiedName: any, isMedium: Observable<any>, isSmall: Observable<any>, isExtraSmall: Observable<any>) {
    if (!entityId) return;
    let apiCall: Observable<any>;
    switch (entityType) {
      case 'AI':
        apiCall = this.meetingService.getTaskHistory(entityId);
        break;
      case 'MN': 
        apiCall = this.meetingService.getHistory(entityId);
        break;
      case 'MD':
        apiCall = this.meetingService.getDecisionHistory(entityId);
        break;
      default:
        return;
    }

    apiCall.subscribe((content: any) => { 
      if (content.body != null) {
        let linkDialog = this.dialog.open(HistoryComponent, {
          data: { content, modifiedName, entityType },
          panelClass: ['animate__animated', 'animate__slideInLeft'],
          disableClose: true,
          position: { left: "0%" },
          maxWidth: "100%",
          maxHeight: "100vh",
          width: "80%",
          height: "100vh"
        });

        const mediumDialogSubscription = isMedium.subscribe(size => {
          if (size.matches) {
            linkDialog.updateSize('70vw', '100vh');
          }
        });

        const smallSubscription = isSmall.subscribe(size => {
          if (size.matches) {
            linkDialog.updateSize('100vw', '100vh');
          }
        });

        const smallDialogSubscription = isExtraSmall.subscribe(size => {
          if (size.matches) {
            linkDialog.updateSize('100vw', '100vh');
          }
        });

        linkDialog.afterClosed().subscribe(() => {
          mediumDialogSubscription.unsubscribe();
          smallSubscription.unsubscribe();
          smallDialogSubscription.unsubscribe();
        });

      } else {
        this.notifier.alertPhemeError(environment_msg.msg_error_no_previous_history_found);        
      }
    }, error => {
        this.notifier.alertPhemeError(error);
    });
  }
}
